<!-- 学习动力 -->
<template>
	<div class="page_part2">
		<div class="page_shadow page_main">
            <TopHeader :title="'学习动力评估结果'" :headerLogo="headerLogo"></TopHeader>
            <h5 class="header page_header">
                <span>Part.4 学习动力</span>
            </h5>
            <h6 class="page_title_2">
                <span>学习动力</span>
                <span class="arrow"></span>
            </h6>
			<div class="header_detail_box">
				<p class="header_detail">学习动力指的是引发并维持学习活动的内部心理倾向。学习动力主要表现在学习态度上，学习态度由认知、情感、行为意向三部分组成，这三部分是协调统一的关系。</p>
			</div>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习动力评估结果
            </p>
            <!--<p class="part_big_title part_big_title_num">{{partIndex}}.1 学习动力评估结果</p>-->
			<div class="page_part2_result result_box">
				<div :class="['detail_box','detail_box'+index]" v-for="(item,index) in norm" :key="index" v-if="index < 3">
					<p class="title"><span></span>{{item.name}}</p>
					<p class="score">水平值：<span>{{item.score | toFixed(1)}}</span></p>
					<p class="score">评价：<span>{{getGrade(item.score)}}</span></p>
				</div>
				<div class="circle_box">
                    <div class="topBox"></div>
                    <div class="middleBox">
                        <div :class="['norm_box','norm_' + item.type]" v-for="(item,index) in norm" :key="index" v-if="index < 3">
                            <div class="norm">
                                <div class="norm_child" v-if="item.type=='qinggan'"  :style="{left: (normDataDongli.qinggan.l_norm-1)/200*180 + 'px', width: (normDataDongli.qinggan.r_norm-normDataDongli.qinggan.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_child" v-if="item.type=='renzhi'"  :style="{left: (normDataDongli.renzhi.l_norm-1)/200*180 + 'px', width: (normDataDongli.renzhi.r_norm-normDataDongli.renzhi.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_child" v-if="item.type=='xingwei'"  :style="{left: (normDataDongli.xingwei.l_norm-1)/200*180 + 'px', width: (normDataDongli.xingwei.r_norm-normDataDongli.xingwei.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_bg"></div>
                                <div class="score" :style="{left: (item.score*180)/200-2.5 + 'px'}" :title="item.score | toFixed(1)"><span>{{item.score | toFixed(1)}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="bottomBox">
                        <p class="title"><span></span>学习动力</p>
                        <p class="score">水平值：<span>{{norm[3].score | toFixed(1)}}</span></p>
                        <p class="score">评价：<span>{{getGrade(norm[3].score)}}</span></p>
                    </div>
                </div>
			</div>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
            <TopHeader :title="'学习动力分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习动力分析
            </p>
            <!--<p class="part_big_title part_big_title_num">{{partIndex}}.2 学习动力分析</p>-->
			<ThePart2Main index="1" :normDataDongli="normDataDongli" :normObj="norm[0]" :comment="comment[0].comment" ></ThePart2Main>
			<ThePart2Main index="2" :normDataDongli="normDataDongli" :normObj="norm[1]" :comment="comment[1].comment" ></ThePart2Main>
            <ThePart2Main index="3" :normDataDongli="normDataDongli" :normObj="norm[2]" :comment="comment[2].comment" ></ThePart2Main>
			<p class="big_page_number">08</p>
		</div>
	</div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
import ThePart2Main from './ThePart2Main.vue';//学习动力/学习动力分析
export default {
	name: 'page_part2',
	components: { TopHeader,ThePart2Main },
    props: {
	    headerLogo:{},
        normDataDongli: {
        },
    	norm: {
	      type: Array//norm数组的其中一项
	      // required: true
	    },
	    comment: {
	   		type: Array//comment的类型解读
	      	// required: true
	    },
	    partIndex: {
	    	type: Number
	    }
    },
    data() {
        return {
        	// comment: null,
        	// norm: []
        }
    },
    watch: {
    },
    created() {	
    	// this.getXxdlInfo()
    },
    mounted() {
    },
    methods: {
    	getGrade(value) {
        if(0<value&&value<40) {
          return '低'
        }else if (40<=value&&value<80){
          return '较低'
        }else if (80<=value&&value<120){
          return '中等'
        }else if (120<=value&&value<160){
          return '较高'
        }else{
          return '高'
        }
    	}
    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_part2 {
	}
</style>
